import { render, staticRenderFns } from "./MuseumTab.vue?vue&type=template&id=88780f24"
import script from "./MuseumTab.vue?vue&type=script&lang=js"
export * from "./MuseumTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports